import React from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import EpdRoutes from 'routes/EpdRoutes';
import { useFeatureFlags } from 'services/api/queries';
import { FeatureFlagKeyDynamicFormsPortal } from 'services/api/featureFlagsApi';

type Props = RouteComponentProps & {
  component: React.ComponentType<RouteComponentProps>;
};

/**
 * Renders the DynamicForms route component only when the DynamicForms.Portal feature flag is enabled.
 * Otherwise redirects to dashboard.
 */
const DynamicFormsGate: React.FC<Props> = ({ component: Component, ...rest }) => {
  const { data: flags, isLoading } = useFeatureFlags();
  const portalEnabled = flags?.[FeatureFlagKeyDynamicFormsPortal] === true;

  if (isLoading) {
    return null; // or a small spinner
  }
  if (!portalEnabled) {
    return <Redirect to={EpdRoutes.dashboard} />;
  }
  return <Component {...rest} />;
};

export default DynamicFormsGate;
